import { FunctionDto } from './../functions/function.dto';
import { IdentityDto } from './../shared/identity.dto';
import { VersionDto } from './../shared/version.dto';
import { EntityDto } from './../entity/entity.dto';

import { ProductImageDto } from './../product/image.dto';
import { ProductInstructionDto } from './../product/instruction.dto';
import { ProductBarCodeDto } from './../product/bar-code.dto';
import { CapabilityDto } from './../shared/capability.dto';
import { ProductFeeDto } from './../product/fee.dto';
import { ProductSupplierDto } from './../product/supplier.dto';
import { ProductDistributionDto } from './../product/distribution/distribution.dto';
import { ProductFulfillmentDto } from './../product/fulfillment/fulfillment.dto';
import { ProductSwapDto } from './../product/swap.dto';
import { ProductSettlementDto } from './../product/settlement/settlement.dto';
import { ProductInventoryDto } from './../product/inventory.dto';
import { ProductRedemptionDto } from './../product/redemption/redemption.dto';
import { ProductProcessingDto } from './../product/processing/processing.dto';
import { ProductVariantDetailsDto } from './../product/variant-details.dto';
import { ProductLabelDto } from './../product/product-label.dto';
import { ProductPackagingDto } from './../product/packaging.dto';
import { ProductAttributeDto } from './../product/attribute.dto';
import { EDesignDetailDto } from './../shared';
import { ProductAccountingDto } from './../product/accounting.dto';

export class ProductDto {
  identity: IdentityDto;
  version?: VersionDto;
  entity: EntityDto;
  type?: string;
  base?: any;
  master?: any;
  account?: any;
  groups?: string[];
  category?: string;
  country?: string;
  locale?: string;
  currency?: string;
  images?: ProductImageDto[];
  instructions?: ProductInstructionDto[];
  barcodes?: ProductBarCodeDto[];
  capabilities?: CapabilityDto[];
  attributes?: ProductAttributeDto[];
  fees?: ProductFeeDto[];
  supplier?: ProductSupplierDto;
  distribution?: ProductDistributionDto;
  fulfillment?: ProductFulfillmentDto;
  swaps?: ProductSwapDto[];
  settlement?: ProductSettlementDto;
  inventory?: ProductInventoryDto;
  processing?: ProductProcessingDto;
  redemption?: ProductRedemptionDto;
  productLabels?: ProductLabelDto[];
  packaging?: ProductPackagingDto;
  variantDetails?: ProductVariantDetailsDto;
  clientId?: string;
  productCode?: string;
  productCodeType?: string;
  productCodeName?: string;
  checkDigit?: string;
  eDesignDetails?: EDesignDetailDto[];
  launchDate?: string;
  internalTestDate?: string;
  iid?: number;
  defaultVariant?: string;
  functions?: FunctionDto[];
  accounting?: ProductAccountingDto;
  template?: string;

  errors?: any[];

  constructor(d?: ProductDto) {
    if (!d) {
      return;
    }

    Object.assign(this, {}, d);

    if (d.functions) {
      this.functions = d.functions.map(f => new FunctionDto(f));
    }

    if (d.fees) {
      this.fees = d.fees.map(f => new ProductFeeDto(f));
    }

    if (d.swaps) {
      this.swaps = d.swaps.map(l => new ProductSwapDto(l));
    }

    if (d.productLabels) {
      this.productLabels = d.productLabels.map(l => new ProductLabelDto(l));
    }

    if (d.attributes) {
      this.attributes = d.attributes.map(a => new ProductAttributeDto(a));
    }

    if (d.settlement) {
      this.settlement = new ProductSettlementDto(d.settlement);
    }

    if (d.entity) {
      this.entity = new EntityDto(d.entity);
    }

    if (d.eDesignDetails) {
      this.eDesignDetails = d.eDesignDetails.map(e => new EDesignDetailDto(e));
    }
  }
}
